// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand-brightorange: rgba(229, 90, 0, 1);
  --upsell-z-index: 99;
  --upsell-reference-layer-z-index: 7999;
  --upsell-skip-button-fz: 24px;
  --upsell-skip-button-background: rgba(255, 255, 255, 1);
  --upsell-skip-button-shadow: 0px 2px 2px rgba(0, 0, 0, 0.101399);
}

.Upsell-tooltip {
  left: initial !important;
  max-width: 400px !important;
  padding: 0;
  right: 20px !important;
  width: 400px;
}

.Upsell-tooltip .Upsell-Market-message-image svg {
  height: 200px;
  width: 400px;
}

.Upsell-tooltip * {
  font-family: 'Lato', sans-serif !important;
}

.Upsell-tooltip .introjs-tooltip-header {
  height: 32px;
  padding: 0;
  position: absolute;
  right: 15px;
  top: 10px;
  width: 32px;
}

.Upsell-tooltip .introjs-tooltiptext {
  padding: 0 !important;
}

.Upsell-tooltip .introjs-arrow {
  display: none !important;
}

.Upsell-highlight {
  box-shadow: none !important;
}

.Upsell-show-element {
  z-index: var(--upsell-z-index) !important;
}

.Upsell-tooltip-reference-layer {
  z-index: var(--upsell-reference-layer-z-index) !important;
  transition: none;
}

.Upsell-tooltip .introjs-skipbutton {
  background: var(--upsell-skip-button-background);
  box-shadow: var(--upsell-skip-button-shadow);
  border-radius: 4px;
  color: var(--brand-brightorange);
  font-size: var(--upsell-skip-button-fz);
  height: 32px;
  line-height: 30px;
  margin-right: 4px;
  width: 32px;
}

.Upsell-overlay {
  display: none;
}

.ToastMessage__Content .InlineAlert__Message {
  word-break: initial;
}
`, "",{"version":3,"sources":["webpack://./src/components/upsell-guide/UpsellGuide.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,sCAAsC;EACtC,6BAA6B;EAC7B,uDAAuD;EACvD,gEAAgE;AAClE;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,UAAU;EACV,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[":root {\n  --brand-brightorange: rgba(229, 90, 0, 1);\n  --upsell-z-index: 99;\n  --upsell-reference-layer-z-index: 7999;\n  --upsell-skip-button-fz: 24px;\n  --upsell-skip-button-background: rgba(255, 255, 255, 1);\n  --upsell-skip-button-shadow: 0px 2px 2px rgba(0, 0, 0, 0.101399);\n}\n\n.Upsell-tooltip {\n  left: initial !important;\n  max-width: 400px !important;\n  padding: 0;\n  right: 20px !important;\n  width: 400px;\n}\n\n.Upsell-tooltip .Upsell-Market-message-image svg {\n  height: 200px;\n  width: 400px;\n}\n\n.Upsell-tooltip * {\n  font-family: 'Lato', sans-serif !important;\n}\n\n.Upsell-tooltip .introjs-tooltip-header {\n  height: 32px;\n  padding: 0;\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  width: 32px;\n}\n\n.Upsell-tooltip .introjs-tooltiptext {\n  padding: 0 !important;\n}\n\n.Upsell-tooltip .introjs-arrow {\n  display: none !important;\n}\n\n.Upsell-highlight {\n  box-shadow: none !important;\n}\n\n.Upsell-show-element {\n  z-index: var(--upsell-z-index) !important;\n}\n\n.Upsell-tooltip-reference-layer {\n  z-index: var(--upsell-reference-layer-z-index) !important;\n  transition: none;\n}\n\n.Upsell-tooltip .introjs-skipbutton {\n  background: var(--upsell-skip-button-background);\n  box-shadow: var(--upsell-skip-button-shadow);\n  border-radius: 4px;\n  color: var(--brand-brightorange);\n  font-size: var(--upsell-skip-button-fz);\n  height: 32px;\n  line-height: 30px;\n  margin-right: 4px;\n  width: 32px;\n}\n\n.Upsell-overlay {\n  display: none;\n}\n\n.ToastMessage__Content .InlineAlert__Message {\n  word-break: initial;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
